<div class="tree-summary-tabs">
  @if (leadingTab(); as leadingTab) {
    <div class="tree-summary-tab" [class.selected]="selectedTab() === 'leading'" (click)="changeSelectedTab('leading')">{{ leadingTab }}</div>
  }
  <div class="tree-summary-tab" [class.selected]="selectedTab() === 'list'" (click)="changeSelectedTab('list')">LISTA</div>
  <div class="tree-summary-tab" [class.selected]="selectedTab() === 'table'" (click)="changeSelectedTab('table')">WG TYPU</div>
  <!-- copies the tab that is showing (0119); a projected leading tab is the parent's content, not the summary -->
  @if (selectedTab() !== 'leading' && aggregatedItems()?.length) {
    <div class="tree-summary-copy" (click)="copy()">{{ copied() ? 'Skopiowano' : 'Kopiuj' }}</div>
  }
</div>

@if (selectedTab() === 'leading') {
  <ng-content></ng-content>
} @else if (selectedTab() === 'list') {
  @for (item of aggregatedItems(); track item.bomItemId) {
    <div class="tree-summary-list-item" [class.tree-summary-list-item-with-mass]="hasMass()">
      <div class="tree-summary-list-item-name" [title]="tooltip(item)">{{ item.name }}</div>
      <div class="tree-summary-list-item-amount">{{ formatAmount(item.amount, item.unit) }}</div>
      @if (hasMass()) {
        <div class="tree-summary-list-item-mass">{{ item.massKg != null ? formatAmount(item.massKg, 'kg') : '—' }}</div>
      }
    </div>
  }
} @else {
  <!-- one section per type, stacked (0089): side by side, three groups needed 600px and the /bom card has 300 -->
  @for (section of tableSections(); track section.type) {
    <div class="tree-summary-table-section">
      <!-- the type's count only: a module and the modules inside it would count each other's mass twice -->
      <div class="tree-summary-list-item tree-summary-list-item-header" [class.tree-summary-list-item-with-mass]="hasMass()">
        <div class="tree-summary-list-item-name">{{ typeLabels[section.type] }}</div>
        <div class="tree-summary-list-item-amount">{{ section.items.length }}</div>
      </div>

      @for (item of section.items; track item.bomItemId) {
        <div class="tree-summary-list-item" [class.tree-summary-list-item-with-mass]="hasMass()">
          <div class="tree-summary-list-item-name" [title]="tooltip(item)">{{ item.name }}</div>
          <div class="tree-summary-list-item-amount">{{ formatAmount(item.amount, item.unit) }}</div>
          @if (hasMass()) {
            <div class="tree-summary-list-item-mass">{{ item.massKg != null ? formatAmount(item.massKg, 'kg') : '—' }}</div>
          }
        </div>
      }
    </div>
  }
}
